import { ApiResponseError } from "@/errors/api/api-response-error";

/**
 * APIレスポンス404エラー
 */
export class ApiResponseNotFoundError extends ApiResponseError {
  /**
   * コンストラクタ
   */
  constructor(message: string, data: unknown = null) {
    super(404, message, data);
  }
}
